Handlebars.registerPartial('alerte-modal', Handlebars.templates['alerte-modal']);
Handlebars.registerPartial('alerte-clipboard', Handlebars.templates['alerte-clipboard']);
Handlebars.registerPartial('alerte-tchap-txt', Handlebars.templates['alerte-tchap-txt']);
Handlebars.registerPartial('alerte-tchap-html', Handlebars.templates['alerte-tchap-html']);

Handlebars.registerPartial('jco-modal', Handlebars.templates['jco-modal']);
Handlebars.registerPartial('jco-clipboard', Handlebars.templates['jco-clipboard']);
Handlebars.registerPartial('jco-tchap-txt', Handlebars.templates['jco-tchap-txt']);
Handlebars.registerPartial('jco-tchap-html', Handlebars.templates['jco-tchap-html']);
Handlebars.registerPartial('coordinate-input-modal', Handlebars.templates['coordinate-input-modal']);